module.exports = __webpack_public_path__ + "static/skills-section-banner-3bfd22978af85c8537b996f0c318d2a3.jpg";